export default {"src":"/_next/static/media/Help_White.30dbce22.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};